<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
        <div class="tags">
        <el-tag
          v-for="tag in breadCrumbs"
          v-if="tag.name"
          :key="tag.name"
          closable
          :type="currentSelect.name === tag.name ? 'success' : ''"
          @close="remove(tag)"
          @click="taglick(tag)">
          {{tag.name}}
        </el-tag>
      </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapState({
      breadCrumbs: state => {
        return state.breadCrumb.breadCrumbs
      },
      currentSelect: state => {
        return state.breadCrumb.currentSelect
      }
    })
  },
  methods: {
    ...mapMutations({
      removeBreadCrumbs: 'breadCrumb/removeBreadCrumbs',
      setCurrentSelect: 'breadCrumb/setCurrentSelect'
    }),
    remove (item) {
      this.removeBreadCrumbs(item.name)
      // if (!this.currentSelect.name) {
      //   this.setCurrentSelect(this.breadCrumbs[this.breadCrumbs.length - 1])
      // }
    },
    taglick (item) {
      // console.log('目前选择路由是 ', item)
      this.setCurrentSelect(item)
      this.$router.push(item.path)
    }
  }
}
</script>
<style lang="scss" scoped>
.tags {
  height: 25px;
  margin-bottom: 20px;
  .el-tag {
    cursor:pointer;
  }
}
</style>
